(() => {
  'use strict';
  if (window.__shopbroCollectionTitleRows) return;
  window.__shopbroCollectionTitleRows = true;
  const selector = '.collection #product-grid > .grid__item:not(.micro-color-card) .card > .card__content .card__information > .card__heading';
  let root = null, observer = null, resize = null, scheduled = false;
  function align() {
    scheduled = false;
    if (!root?.isConnected) return;
    const headings = [...root.querySelectorAll(selector)];
    // Reset only our inline reservation before measuring full, untruncated titles.
    for (const heading of headings) heading.style.minHeight = '';
    const rows = new Map();
    for (const heading of headings) {
      const item = heading.closest('#product-grid > .grid__item');
      if (!item || !item.offsetWidth) continue;
      const key = Math.round(item.offsetTop);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push({heading, height: heading.getBoundingClientRect().height});
    }
    for (const row of rows.values()) {
      const height = Math.ceil(Math.max(...row.map(item => item.height)));
      for (const {heading} of row) heading.style.minHeight = `${height}px`;
    }
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(align); }
  }
  function mount() {
    const candidate = document.querySelector('#ProductGridContainer');
    if (!candidate || !candidate.querySelector(selector)) return;
    if (candidate !== root) {
      observer?.disconnect(); resize?.disconnect(); root = candidate;
      observer = new MutationObserver(schedule);
      observer.observe(root, {childList: true, subtree: true});
      let width = -1;
      if ('ResizeObserver' in window) {
        resize = new ResizeObserver(entries => {
          const next = entries[0]?.contentRect.width;
          if (next !== width) { width = next; schedule(); }
        });
        resize.observe(root);
      }
    }
    schedule();
  }
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', mount);
  if (document.fonts) {
    document.fonts.ready.then(schedule);
    document.fonts.addEventListener('loadingdone', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});
  else mount();
})();
